<template>
    <router-view class="sub-view"></router-view>
</template>

<script>
export default {
    components:{
    },
    data:function(){
        return{
        }
    },
    mounted: function(){
    },
    methods:{
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/blank.vue